export default {
  'Your win': 'Twoja wygrana',
  'Select skins that you want to take': 'Wybierz skiny, które chcesz zabrać',
  'By price': 'Według ceny',
  '(Autotrade will receive after 10 minutes)':
    '(Automatyczna wymiana handlowa nastąpi po 10 minutach)',
  ACCEPT: 'Potwierdź',
  'SELECT ALL': 'SELECT ALL',
};
